import React from 'react';
import { SelectChangeEvent, useMediaQuery, useTheme } from '@mui/material';
import { Select, Tab, Tabs, MenuItem } from '~/UIKit';

interface IDynamicNavigationProps<T> {
  onChange: (string: string) => void;
  value: T;
  className: string;
  items: ({ value: string; label: string } | undefined)[];
}

export const DynamicNavigation = <T extends object>({
  onChange,
  value,
  className,
  items,
}: IDynamicNavigationProps<T>) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const cleanItems = items.filter((item) => item !== undefined) as {
    value: string;
    label: string;
  }[];

  const onSelectChange = (event: SelectChangeEvent<any>) => {
    event.preventDefault();
    onChange(event.target.value);
  };

  const onTabChange = (event: any, value: string) => {
    event.preventDefault();
    onChange(value);
  };

  if (isMobile) {
    return (
      <Select newDesign onChange={onSelectChange} value={value} className={className}>
        {cleanItems.map((item, index) => (
          <MenuItem key={`navigation_item_${index}`} value={item.value}>
            {item.label}
          </MenuItem>
        ))}
      </Select>
    );
  }
  return (
    <Tabs onChange={onTabChange} value={value} className={className}>
      {cleanItems.map((item, index) => (
        <Tab key={`navigation_item_${index}`} value={item.value} label={item.label} />
      ))}
    </Tabs>
  );
};
